import { Edit } from 'react-admin'

import KidSeriesForm from './KidSeriesForm'

const KidSeriesEdit = props => (
  <Edit undoable={false} {...props}>
    <KidSeriesForm />
  </Edit>
)

export default KidSeriesEdit
